import { Show, SimpleShowLayout, TextField, type ShowProps } from "react-admin";
import DisplayDateField from "@/components/DisplayDateField";

export const HouseVisitEventShow = (props: ShowProps) => (
  <Show {...props}>
    <SimpleShowLayout sx={{ maxWidth: { xs: "100%", sm: 560 } }}>
      <TextField source="name" />
      <TextField source="hijriYear" label="Hijri year" />
      <DisplayDateField source="fromDate" label="From" />
      <DisplayDateField source="toDate" label="To" />
    </SimpleShowLayout>
  </Show>
);
